module.exports = __webpack_public_path__ + "img/f.99b1dfee.png";